import { createSlice } from '@reduxjs/toolkit';
import { incidentsApi } from '../functions/IncidentsApi';
import { toast } from 'react-toastify';

const initialState = {
  importLogList: [],
  loading: false,
};

export const importHistoryReducer = createSlice({
  name: 'incidentsReducer',
  initialState,
  reducers: {
    setImportLogList: (state, action) => {
      state.importLogList = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
  },
});

export const { setImportLogList, setLoading } = importHistoryReducer.actions;

export default importHistoryReducer.reducer;

export const getImportLog =
  (currentPage, searchQuery, limit) => async (dispatch, getState) => {
    try {
      const { importLogList } = getState().importHistoryReducer;

      if (importLogList.length > 0) {
        dispatch(setImportLogList([]));
      }
      dispatch(setLoading(true));
      const response = await incidentsApi.getImportLog(
        currentPage,
        searchQuery,
        limit
      );

      if (response.status === 200) {
        dispatch(setImportLogList(response.data.data));
      } else throw new Error('No data received from API');
    } catch (err) {
      console.log(err);
    } finally {
      dispatch(setLoading(false));
    }
  };

export const forceImport = (id) => async (dispatch) => {
  try {
    const response = await incidentsApi.forceImport(id);
    if (response.status === 200) {
      toast.success('Forced import successfully');
      return true;
    } else throw new Error('No data received from API');
  } catch (err) {
    console.log(err);
    toast.error('Forced import error occurred');
  }
};

export const downloadImportHistory = (id) => async (dispatch) => {
  try {
    const response = await incidentsApi.downloadImport(id);

    if (response.status === 200) {
      const xmlContent = response.data;
      const blob = new Blob([xmlContent], { type: 'text/xml' });

      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = `${id}.xml`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else throw new Error('No data received from API');
  } catch (err) {
    toast.error('No data received from API');
  }
};
